import BookIndex from "components/shared/book/list";
import List from "components/shared/list";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import React from "react";

class SystemCatalogs extends BookIndex {
    thead = () => {
        return (
            <thead>
                <tr>
                    <th>Название</th>
                    <th className="text-center">Количество опций</th>
                </tr>
            </thead>
        );
    };

    renderCounter = () => null;

    renderListComponent = () => {
        const { isTable } = this.props;
        return (
            <List
                {...this.props}
                items={this.props.items.filter((item) => !!item.organizationId)}
                isTable={!!isTable}
                renderRow={this.renderTableRow}
                renderHead={this.thead}
            />
        );
    };

    renderTableRow = (item) => {
        return (
            <tr key={item.id} onClick={() => this.props.history.push(paths.systemCatalogsShow(item.id))}>
                <td>{item.displayName}</td>
                <td className="text-center">{item.items ? item.items.length : ""}</td>
            </tr>
        );
    };
}

export default tableContainer(SystemCatalogs, "dictionaries");
